import {Capacitor} from '@capacitor/core';
import {AppUpdate, AppUpdateAvailability} from '@capawesome/capacitor-app-update';
import {logInProduction} from '$lib/utils/logInProduction';
import {timer} from '$lib/utils/timer';
import {LiveUpdate} from '@capawesome/capacitor-live-update';

export class MobileUpdateManager {
    nextBundleId: string | null = null;

    constructor(
        private readonly platform: string,
        private readonly isNativePlatform: boolean
    ) {}

    async checkForUpdates() {
        if (!this.isNativePlatform) return

        // check for native app update
        if (Capacitor.isPluginAvailable('AppUpdate')) {
            try {
                const appUpdateTimer = timer('AppUpdate')
                const result = await AppUpdate.getAppUpdateInfo();
                const currentVersion = this.platform === 'android' ? result.currentVersionCode : result.currentVersionName;
                const availableVersion = this.platform === 'android' ? result.availableVersionCode : result.availableVersionName;
                const updateAvailable = result.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE;
                logInProduction('AppUpdate - currentVersion', currentVersion, 'availableVersion', availableVersion, 'updateAvailable', updateAvailable);
                appUpdateTimer()
                if (updateAvailable) {
                    if (this.platform === 'android') {
                        if (result.immediateUpdateAllowed) {
                            logInProduction('ANDROID - UPDATE AVAILABLE - IMMEDIATE UPDATE ALLOWED');
                            const appUpdateResult = await AppUpdate.performImmediateUpdate();
                            logInProduction('appUpdateResult', appUpdateResult);
                        } else {
                            console.error('ERROR - update available but NO IMMEDIATE update allowed')
                        }
                    } else if (this.platform === 'ios') {
                        // TODO what's the best way to handle on iOS?
                        await AppUpdate.openAppStore();
                    }
                }
            } catch (error) {
                console.error('ERROR checking AppUpdate', error)
            }
        } else {
            console.error('ERROR AppUpdate Plugin not available on Native Platform ?!')
        }

        // check for Capawesome live update
        if (Capacitor.isPluginAvailable('LiveUpdate')) {
            try {
                const liveUpdateTimer = timer('LiveUpdate')
                const {versionCode} = await LiveUpdate.getVersionCode();
                const channel = `${import.meta.env.MODE}-${versionCode}`
                logInProduction('LiveUpdate - channel', channel)

                await LiveUpdate.setChannel({channel});

                const {bundleId} = await LiveUpdate.getCurrentBundle()
                const {nextBundleId} = await LiveUpdate.sync(); //checks and downloads the latest bundle, applied at next app start

                logInProduction('LiveUpdate - current >> ', bundleId, 'next >>', nextBundleId)
                liveUpdateTimer()

                this.nextBundleId = nextBundleId;

                // await LiveUpdate.fetchLatestBundle(); // use to get customProperties to maybe decide if a reload should be done instantly
                // and not only on next app start or next time when app is resumed/gets focus/isActive again

            } catch (error) {
                console.error('ERROR checking LiveUpdate', error)
            }
        } else {
            console.error('ERROR LiveUpdate Plugin not available on Native Platform ?!')
        }
    }

    async reloadIfUpdateAvailable() {
        if (!this.isNativePlatform) return
        if (this.nextBundleId) await LiveUpdate.reload(); //Reload the app to apply the new bundle
    }
}